import { defined, size } from 'junctions-fp'
/**
 * Insctance of EffectCommand
 */
export default class OpacityCommand {
  /**
   * Creates an instance of EffectCommand.
   * @param {PixelEditor} target l'objet pixeleditor
   * @param {Filter} filter un objet filter
   * @memberof EffectCommand
   */
  constructor(target, newValue, oldValue) {
    this.label = 'opacity'
    this.target = target
    this.newValue = newValue
    this.oldValue = oldValue
    this.element = this.target.canvas.getActiveObject()
  }
  /**
   *  Execute la command
   *
   */
  execute() {
    const canvas = this.target.canvas
    if (defined(this.element)) {
      this.element.set({
        opacity: this.newValue
      })
      canvas.requestRenderAll()
    }
  }
  /**
   * Annule l'effet de la commande
   *
   */
  undo() {
    const canvas = this.target.canvas
    this.element.set({
      opacity: this.oldValue
    })
    canvas.requestRenderAll()
  }
}



// WEBPACK FOOTER //
// ./src/model/pixel/command/OpacityCommand.js